import { render, staticRenderFns } from "./CandidateShow.vue?vue&type=template&id=721621a4&"
import script from "./CandidateShow.vue?vue&type=script&lang=js&"
export * from "./CandidateShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports